export enum OrganisationType {
    Business = 1,
    Education = 2
}